import { defineComponent as _defineComponent } from 'vue'
import { watch, ref } from 'vue';
import { useI18n } from 'vue-i18n-composable';
import moment, { updateLocale } from 'moment';
import { CLOCK_UPDATE_DELAY } from '@/constants/components/ClockComponent';
import relativeTimeByLocales, { langToLocale } from '@/constants/i18n/relative';
import './styles/clock-component.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClockComponent',
  setup(__props) {

const currentTime = ref('');

const currentDate = ref('');

const i18n = useI18n();

const updateDelay = CLOCK_UPDATE_DELAY;

watch(
  () => i18n.locale.value,
  () => {
    updateLocale(i18n.locale.value, relativeTimeByLocales[i18n.locale.value]);
    currentDate.value = moment().format(`${langToLocale[i18n.locale.value].format}`).toString();
  },
  {
    immediate: true,
    deep: true
  }
);

function getCurrentTime(refreshDelay: number): void {
  setInterval(() => { currentTime.value = moment().format('HH:mm').toString(); }, refreshDelay);
}

getCurrentTime(updateDelay);

return { __sfc: true,currentTime, currentDate, i18n, updateDelay, getCurrentTime }
}

})